import React, { useEffect, useState } from "react";
import { EntityLink } from "@/components/EntityLink";
import { api, euro } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Card as FCard } from "@/components/ui/card";
import { toast } from "sonner";
import { Copy, Mail } from "lucide-react";

export default function GiftCards() {
  const [cards, setCards] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [sent, setSent] = useState("all");

  useEffect(() => { api.get("/giftcards").then((r) => setCards(r.data)).catch(() => {}); }, []);

  const copy = (code) => { navigator.clipboard?.writeText(code); toast.success("Codice copiato"); };

  const filtered = cards.filter((c) => {
    const d = (c.created_at || "").slice(0, 10);
    if (start && d < start) return false;
    if (end && d > end) return false;
    if (sent === "sent" && !c.gift_email_sent) return false;
    if (sent === "not_sent" && c.gift_email_sent) return false;
    return true;
  });

  return (
    <div className="space-y-6" data-testid="giftcards-page">
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Vendite</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Storico Gift Card</h1>
      </div>
      <FCard className="p-5 glow-border">
        <div className="grid sm:grid-cols-3 gap-4">
          <div>
            <Label>Dal</Label>
            <Input type="date" className="mt-1.5" data-testid="giftcard-start-date" value={start} onChange={(e) => setStart(e.target.value)} />
          </div>
          <div>
            <Label>Al</Label>
            <Input type="date" className="mt-1.5" data-testid="giftcard-end-date" value={end} onChange={(e) => setEnd(e.target.value)} />
          </div>
          <div>
            <Label>Consegna email</Label>
            <Select value={sent} onValueChange={setSent}>
              <SelectTrigger className="mt-1.5" data-testid="giftcard-sent-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tutte</SelectItem>
                <SelectItem value="sent">Inviata</SelectItem>
                <SelectItem value="not_sent">Non inviata</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </FCard>
      <Card className="glow-border">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Prodotto</TableHead><TableHead>Codice</TableHead><TableHead>Prezzo vendita</TableHead>
            <TableHead>Margine</TableHead><TableHead>Addebito</TableHead>
            <TableHead>Email</TableHead><TableHead>Data</TableHead><TableHead></TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {filtered.map((c) => (
              <TableRow key={c.id} data-testid={`giftcard-row-${c.id}`}>
                <TableCell className="font-medium"><EntityLink kind="order" id={c.id} data-testid={`giftcard-order-link-${c.id}`}>{c.product_name}</EntityLink></TableCell>
                <TableCell className="font-mono tracking-wider">{c.gift_code || "—"}</TableCell>
                <TableCell className="font-medium">{euro(c.amount)}</TableCell>
                <TableCell>{c.earning != null ? <span className="text-teal-500 font-medium" data-testid={`giftcard-margin-${c.id}`}>+ {euro(c.earning)}{c.margin_percent != null && <span className="text-xs text-muted-foreground ml-1">({c.margin_percent}%)</span>}</span> : <span className="text-muted-foreground">—</span>}</TableCell>
                <TableCell>{c.debit != null ? <span className="font-medium">{euro(c.debit)}</span> : <span className="text-muted-foreground">—</span>}</TableCell>
                <TableCell className="text-sm">
                  {c.gift_email
                    ? <span className="inline-flex items-center gap-1 text-muted-foreground"><Mail className="w-3.5 h-3.5" />{c.gift_email}{c.gift_email_sent ? <Badge className="ml-1 bg-teal-600 hover:bg-teal-600">inviata</Badge> : <Badge variant="outline" className="ml-1">non inviata</Badge>}</span>
                    : <span className="text-muted-foreground">—</span>}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">{new Date(c.created_at).toLocaleDateString("it-IT")}</TableCell>
                <TableCell>
                  {c.gift_code && <Button size="icon" variant="ghost" onClick={() => copy(c.gift_code)} data-testid={`giftcard-copy-${c.id}`}><Copy className="w-4 h-4" /></Button>}
                </TableCell>
              </TableRow>
            ))}
            {cards.length === 0 && <TableRow><TableCell colSpan={8} className="text-center text-muted-foreground py-8">Nessuna gift card venduta.</TableCell></TableRow>}
            {cards.length > 0 && filtered.length === 0 && <TableRow><TableCell colSpan={8} className="text-center text-muted-foreground py-8">Nessuna gift card per i filtri selezionati.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
